import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const BookPurchaseList = createAsyncThunk(
  'book-purchase-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-book-purchase/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeBookPurchase = createAsyncThunk(
  'book-purchase-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-book-purchase/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getBookPurchaseById = createAsyncThunk(
  'book-purchase-get',
  async (purchase_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-book-purchase/edit/` + purchase_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const approveBookPurchase = createAsyncThunk(
  'book-purchase-approve',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-book-purchase/approve/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const viewBookPurchase = createAsyncThunk(
  'book-purchase-view',
  async (purchase_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-book-purchase/view/` + purchase_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

type BookPurchaseState = {
  errors: any
}

const initialState: BookPurchaseState = {
  errors: '',
}

export const bookPurchaseSlice = createSlice({
  name: 'book-purchase',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeBookPurchase.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = bookPurchaseSlice.actions
export default bookPurchaseSlice.reducer
